import AbstractGuestlistDetailsPageController from '../abstract-details-controller';
import guestlistModelReducer from '../../../../helpers/guestlist-model-reducer';
import askForLeavingWithoutSavingChanges
    from '../../../../../../modules/core/helpers/routing/ask-for-leaving-without-saving-changes';
import addTicketTemplateModalCreator
    from '../../../../../../modules/tickets/templates/helpers/add-ticket-template-modal-creator';
import addWalletTemplateModalCreator
    from '../../../../../../modules/wallets/templates/helpers/add-wallet-template-modal-creator';
import guestlistEditAlertHandler from '../../../../../../modules/guestlists/helpers/guestlist-edit-alert-handler';
import walletTemplateModelReducer from '../../../../../../modules/wallets/templates/helpers/template-model-reducer';

export default class GuestlistTicketSettingsPageController extends AbstractGuestlistDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        askForLeavingWithoutSavingChanges(this);
        this.depositService = this.injector.get('Deposit');

        this.originalModel = true;
        this.model = null;
        this.messageTicketFlows = [];
        this.submitting = false;

        this.allowRoute = true;

        this._initDeposits();

        this.pdfTicketEnabled = this.acl.hasModule('tickets');
        this.walletTicketEnabled = this.acl.hasModule('passbooks');

        this.pdfTicket = null;
        this.loadingPdfPreview = false;
        this.walletTicket = null;
        this.loadingWalletPreview = true;
        this.walletPreviewSlide = 1;
        this.walletPreviewColors = {
            background: '',
            fore: '',
            label: ''
        };
        this.walletPreviewData = {};
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        const reducedModel = guestlistModelReducer(this.guestlist, _.get(this.userStore, 'state.company', null));
        this.originalModel = {
            settings: {
                messages_ticket_flow: _.get(reducedModel, 'settings.messages_ticket_flow'),
                disable_pax_planned_0_tickets: _.get(reducedModel, 'settings.disable_pax_planned_0_tickets'),
                attach_ticket_to_confirmation_email: _.get(reducedModel, 'settings.attach_ticket_to_confirmation_email'),
                attach_passbook_to_confirmation_email: _.get(reducedModel, 'settings.attach_passbook_to_confirmation_email'),
            }
        };

        this.model = _.cloneDeep(this.originalModel);
        this._updateDataChanged();

        this.pdfTicket = null;
        this.walletTicket = null;
        this.loadingPdfPreview = true;

        const jobsToWaitFor = [];
        if (this.pdfTicketEnabled && this.guestlist.ticket_template_id) {
            jobsToWaitFor.push(
                this.api
                    .get(`tickets/templates/${this.guestlist.ticket_template_id}`)
                    .then(({data}) => {
                        this.pdfTicket = data.data;
                        this.api
                            .post(`tickets/templates/types/${this.pdfTicket.template_type_id}/render-from-definition`, {
                                definition: this.pdfTicket.type_definition
                            })
                            .then(({data}) => {
                                this.loadingPdfPreview = false;

                                const iFrame = angular.element('#pdf-ticket-template-preview'),
                                    iFrameContainer = angular.element('#pdf-ticket-template-preview-container');

                                if (iFrame && iFrame[0]) {
                                    const contentWindow = iFrame[0].contentWindow.document;
                                    if (contentWindow) {
                                        contentWindow.open();
                                        contentWindow.write(data);
                                        contentWindow.close();
                                    }

                                    iFrameContainer.css('height', 'auto');
                                    iFrame.css({
                                        'transform': 'none'
                                    });

                                    let scaleRatio = 1;
                                    if (iFrame.width() > iFrameContainer.width()) {
                                        scaleRatio = Math.round((iFrameContainer.width() / iFrame.width()) * 10000) / 10000;

                                        iFrame.css({
                                            'transform': 'scale(' + scaleRatio + ')'
                                        });
                                    }

                                    iFrameContainer.css('height', (iFrame.height() * scaleRatio) + 'px');
                                }
                            })
                    })
                    .catch(e => this.alert.handle(e))
            );
        }

        if (this.walletTicketEnabled && this.guestlist.passbook_id) {
            jobsToWaitFor.push(
                this.api
                    .get(`wallets/templates/${this.guestlist.passbook_id}`)
                    .then(({data}) => {
                        this.walletTicket = data.data;

                        this.loadingWalletPreview = true;
                        this.api
                            .post('wallets/templates/render-preview', {
                                rsvp_id: null,
                                template: walletTemplateModelReducer(this.walletTicket)
                            })
                            .then(({data}) => {
                                this.walletPreviewData = data.data;
                                this.loadingWalletPreview = false;
                                this.walletPreviewSlide = 1;

                                _.map(this.walletPreviewColors, (val, key) => {
                                    const apiColor = this.walletPreviewData.colors[`${key}_color`];

                                    this.walletPreviewColors[key] = `rgb(${apiColor.red},${apiColor.green},${apiColor.blue})`;
                                })
                            })
                            .catch((e) => {
                                console.log(e);
                                this.alert.handle(e);
                            })
                    })
                    .catch(e => this.alert.handle(e))
            );
        }

        if (jobsToWaitFor.length > 0) {
            this.loading = true;

            this.injector
                .get('$q')
                .all(jobsToWaitFor)
                .then(() => {
                    this.loading = false;
                })
        }
    }

    changeWalletTicketView(newView) {
        this.walletTicketView = newView;
        this.scope.$applyAsync();
    }

    startAddPdfTicket() {
        addTicketTemplateModalCreator(this.injector)
            .then(({ticketTemplate}) => {
                this.loading = true;

                this._updateGuestlistSettings({
                    ticket_template_id: ticketTemplate.id
                })
                    .then(() => {
                        this.alert.success(
                            this.translate.instant('general.alerts.create_success.title'),
                            this.translate.instant('general.alerts.create_success.content')
                        );

                        this.state.go('app.guestlists.rsvps.tickets.pdf-ticket', {
                            ...this.stateParams,
                            guestlist: _.cloneDeep(this.guestlist)
                        }, {
                            notify: true,
                            reload: false,
                            inherit: true,
                            location: true
                        });
                    });
            })
            .catch(() => {

            });
    }

    removePdfTicket() {
        this._updateGuestlistSettings({
            ticket_template_id: null
        }).then(() => {
            this.alert.success(
                this.translate.instant('general.alerts.remove_success.title'),
                this.translate.instant('general.alerts.remove_success.content')
            );
        });
    }

    startAddWalletTicket() {
        addWalletTemplateModalCreator(this.injector)
            .then(({walletTemplate}) => {
                    this.loading = true;

                    this._updateGuestlistSettings({
                        passbook_id: walletTemplate.id
                    })
                        .then(() => {
                            this.alert.success(
                                this.translate.instant('general.alerts.create_success.title'),
                                this.translate.instant('general.alerts.create_success.content')
                            );

                            this.state.go('app.guestlists.rsvps.tickets.wallet-ticket', {
                                ...this.stateParams,
                                guestlist: _.cloneDeep(this.guestlist)
                            }, {
                                notify: true,
                                reload: false,
                                inherit: true,
                                location: true
                            });
                        });
                }
            )
            .catch(() => {
            });
    }

    removeWalletTicket() {
        this
            ._updateGuestlistSettings({
                passbook_id: null
            })
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.remove_success.title'),
                    this.translate.instant('general.alerts.remove_success.content')
                );
            });
    }

    _updateGuestlistSettings(overrideData) {
        this.loading = true;

        return this.api
            .put(
                `guestlists/${this.guestlist.id}`,
                {
                    ...guestlistModelReducer(this.guestlist),
                    ...overrideData
                },
                {
                    headers: {
                        'x-festzelt-os-guestlist-version-hash': this.guestlist.version_hash
                    }
                }
            )
            .then(() => {
                return this._loadGuestlist();
            })
            .catch((e) => {
                return guestlistEditAlertHandler(this.injector, e)
                    .catch((e) => {
                        this.alert.handle(e);
                    })
                    .finally(() => {
                        return this._loadGuestlist();
                    });
            })
    }

    discardChanges() {
        this.model = _.cloneDeep(this.originalModel);
    }

    save() {
        this.submitting = true;
        this.api
            .put(
                `guestlists/${this.guestlist.id}/settings`,
                this.model,
                {
                    headers: {
                        'x-festzelt-os-guestlist-version-hash': this.guestlist.version_hash
                    }
                }
            )
            .then(() => {
                this._loadGuestlist();
                this.submitting = false;
            })
            .catch(e => {
                return guestlistEditAlertHandler(this.injector, e)
                    .catch((e) => {
                        this.alert.handle(e);
                    })
                    .finally(() => {
                        this.submitting = false;
                        return this._loadGuestlist();
                    });
            });
    }

    _initDeposits() {
        this.depositService.getRemoteDeposit('guestlists', 'settings', {
            messages_ticket_flows: {}
        }).then((result) => {
            this.messageTicketFlows = [];

            _.each(result.messages_ticket_flows, (v, k) => {
                this.messageTicketFlows.push({
                    value: k,
                    label: v
                });
            });
        });
    }

    _updateDataChanged() {
        this.dataChanged = !_.isEqual(this.model, this.originalModel);
        this.allowRoute = !this.dataChanged;

        this.scope.$applyAsync();
    }

    _initWatchers() {
        super._initWatchers();

        this.scope.$watch(
            () => this.model,
            () => {
                this._updateDataChanged();
            },
            true
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/tickets/ticket-settings-controller.js